import util             from 'util/Util.js';

class SpecialFormList {
    getSpecialFormList(){
        return  [
            { text: 'App - Stage', value: 'stage' },
            { text: 'App - Role', value: 'role' },
            { text: 'App - Instance Name', value: 'instancename' },
            { text: 'App - Instance Number', value: 'instancenumber' },
            { text: 'App - Instance ID', value: 'instanceid' },
            { text: 'App - Instances Count', value: 'instancescount' },
            { text: 'App - URL', value: 'formurl' },
            { text: 'App - Parent Instance Name', value: 'parentinstancename' },
            { text: 'App - Parent Instance Number', value: 'parentinstancenumber' },
            { text: 'App - Parent Instance ID', value: 'parentinstanceid' },
            { text: 'App - Child Instance Names', value: 'childinstancesname' },
            { text: 'App - Child Instance Numbers', value: 'childinstancesnumber' },
            { text: 'App - Child Instance IDs', value: 'childinstancesid' },
            { text: 'App - Is in Read-Only State', value: 'isreadonly' },
            { text: 'App - Displayed Language', value: 'displayedlanguage' },
            { text: '----------', value: 'separator' },
            { text: 'Behavior - Last Command was Successful', value: 'lastcommandsuccess' },
            { text: 'Behavior - Last Command\'s Error Code', value: 'lastcommanderror' },
            { text: 'Behavior - Last Behavior\'s Return Value', value: 'return' },
            { text: 'Util - Current Time', value: 'currenttime' },
            { text: 'Util - Current Date', value: 'currentdate' },
            { text: 'Util - Server Date', value: 'serverdate' },
            { text: 'Util - Server Time', value: 'servertime' },
            { text: 'Util - New Line', value: 'newline' },
            { text: '----------', value: 'separator' },
            { text: 'User - First Name', value: 'userfirstname' },
            { text: 'User - Last Name', value: 'userlastname' },
            { text: 'User - Full Name', value: 'username' },
            { text: 'User - Email', value: 'useremail' },
            { text: 'User - Title', value: 'usertitle' },
            { text: 'User - Street Line 1', value: 'useraddress1' },
            { text: 'User - Street Line 2', value: 'useraddress2' },
            { text: 'User - City', value: 'usertown' },
            { text: 'User - Zip Code', value: 'userzipcode' },
            { text: 'User - State/Province', value: 'userstateprovince' },
            { text: 'User - Country (ISO)', value: 'usercountryiso' },
            { text: 'User - Phone', value: 'usertelephone' },
            { text: 'User - Fax', value: 'userfax' },
            { text: 'User - Mobile Phone', value: 'usercellphone' },
            { text: 'User - Skype', value: 'userskype' },
            { text: 'User - Alternate Email', value: 'useralternateemail' },
            { text: 'User - Custom ID', value: 'usercustomid' },
            { text: 'User - Domain Username', value: 'userdirectoryserviceusername' },
            { text: 'Gateway - HTTP USER', value: 'gatewayhttpuser' }
        ];
    }

    getSpecialDataSourceList(dataSouce){
      
        let list = [];
        let item;
         _.forEach(dataSouce.Field, (field) => {
           if(util.isTrue(field.inUse) || util.isTrue(field.meta)){
             let name =  field.displayName === '' ? field.name : field.displayName;
             item =  { text: name, value: field.name, dataType: field.dataType };
             list.push(item);
           }
        });
        return  list;
    }

    getChartlDataSourceList(dataSouce){
      
        let list = [];
        let item;
         _.forEach(dataSouce.Field, (field) => {
           if(util.isTrue(field.inUse) || util.isTrue(field.meta)){
             let name =  field.displayName === '' ? field.name : field.displayName;
             item =  { text: name, value: field.id };
             list.push(item);
           }
        });
        return  list;
    }
    
    getTextValue(value) {
        let text = '';

        const found = _.find(this.getSpecialFormList(), function (obj) {
            return obj.value === value;
        });

        text = found ? found.text : value;
        return text;
    }
}



// A singleton. Exports instance, not the class.
const specialFormList = new SpecialFormList;
export default specialFormList;
